import React, { useEffect } from "react"
import useFormateDate from "../../hooks/useFomateDate"
import { Link } from "react-router-dom"

function OrderItem({ order }) {
	useEffect(() => {})
	return (
		<li
			key={order.id}
			className="py-[10px] grid grid-cols-[1fr_1fr_75px] md:grid-cols-[1fr_1fr_1fr_1fr_80px_70px] gap-[1rem] border-b-[1px] border-[#fff5eb]"
		>
			<div className="flex flex-col gap-[5px]">
				<div className="text-[14px] leading-[1] line-clamp-1 text-ellipsis">
					{order.patient?.firstName}
				</div>
				<div className="text-[12px] leading-[1] text-[#6C6C6C]">
					Full Name
				</div>
			</div>
			<div className="hidden md:flex flex-col gap-[5px] ">
				<div className="text-[14px] leading-[1]">
					#{order.orderNumber}
				</div>
				<div className="text-[12px] leading-[1] text-[#6C6C6C]">
					Order Number
				</div>
			</div>
			<div className="hidden md:flex flex-col gap-[5px]">
				<div className="text-[14px] leading-[1]">{`${order.currency} ${order.total}`}</div>
				<div className="text-[12px] leading-[1] text-[#6C6C6C]">
					Amount
				</div>
			</div>
			<div className="flex flex-col justify-start text-left gap-[5px]">
				<div className="text-[14px] text-left leading-[1] w-full">
					{useFormateDate(order.dateCreated)}
				</div>
				<div className="text-[12px] leading-[1] text-[#6C6C6C]">
					Date
				</div>
			</div>
			<div className="flex sm:hidden flex-col gap-[5px]">
				<div className="text-[14px] leading-[1]">{order.status}</div>
				<div className="text-[12px] leading-[1] text-[#6C6C6C]">
					Status
				</div>
			</div>
			<Link
				to={`/orders/${order.orderNumber}`}
				className="text-[#F19B3E] text-center bg-[#FEF7F0] hover:bg-[#F19B3E] hover:text-[#ffffff] active:bg-[#ffffff] active:text-[#F19B3E] text-[12px] leading-[27px] pb-[2px] rounded-[2px] px-[15px]"
			>
				View
			</Link>
		</li>
	)
}

export default OrderItem
